import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { Wrapper, TextWrapper, FlexRow } from "../../../constants/common/StyledGlobalConstants";
import { DEVICE_BREAKPOINTS } from "../../../constants/appConstants";

const { TABLET } = DEVICE_BREAKPOINTS;

const ServiceTotal = ({ fees }) => {
  const { windowSize } = useSelector((state) => state.ACCOUNT);
  const isMobile = windowSize.width < TABLET;
  return (
    <Wrapper marginTop={isMobile ? "1.5rem" : "2rem"}>
      <FlexRow justifyContent="space-between" height="3.5rem" borderTop="1px solid #D8DADA" borderBottom="3px solid #000" alignItems="center">
        <TextWrapper fontSize="1rem" fontWeight="700" lineHeight="1.375rem">
          Service total
        </TextWrapper>
        <TextWrapper fontSize="1.25rem" fontWeight="700" lineHeight="1.5rem">
          {fees ? `$${fees.toFixed(2)}` : ""}
        </TextWrapper>
      </FlexRow>
      {fees && (
        <TextWrapper marginTop="0.5rem !important" width="fit-content" fontSize="0.75rem" fontWeight="400" lineHeight="1.125rem" color="#6F7171">
          The service total reflects the services and equipment listed above. Additional equipment may involve an extra fee. You'll receive an invoice
          for the final charges. Taxes are excluded.
        </TextWrapper>
      )}
    </Wrapper>
  );
};

ServiceTotal.propTypes = {
  fees: PropTypes.number
};

export default ServiceTotal;